import { connect, type ConnectedProps } from 'react-redux';

import {
  getTestimonials,
  getTestimonialsFetching,
} from '../../store/testimonials/selectors';
import { loadTestimonials } from '../../store/testimonials/actions';
import withMobile from '../../hocs/withMobile';

import Testimonials from './Testimonials';

const mapStateToProps = (state) => ({
  items: getTestimonials(state),
  isFetching: getTestimonialsFetching(state),
});

const mapDispatchToProps = (dispatch) => ({
  load: () => dispatch(loadTestimonials()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(withMobile(Testimonials));
